module.exports = __webpack_public_path__ + "/804c91553615388a8293a719c330c6b1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/white-labeling/assets/2.png
 ** module id = 934
 ** module chunks = 0
 **/